<template>
  <b-input-group
    :class="inputGroupClass"
  >
    <b-input-group-prepend
      @click="togglePicker"
      v-if="withIcon && isLeft"
    >
      <v-icon name="calendar" />
    </b-input-group-prepend>
    <flat-pickr
      v-model="value"
      :id="fpId"
      :class="extraClasses"
      :config="config"
      :placeholder="$attrs.placeholder"
      :disabled="disabled"
      @on-change="onChange"
      @on-close="onClose"
      @on-open="onOpen"
    />
    <b-input-group-append
      @click="togglePicker"
      v-if="withIcon && isRight"
    >
      <b-button size="xs">
        <v-icon name="calendar" />
      </b-button>
    </b-input-group-append>
  </b-input-group>
</template>

<script>
export default {
  name: 'Datepicker',
  inheritAttrs: false,
  props: {
    id: String,
    options: {
      type: Object,
      default: () => ({}),
    },
    hasClear: {
      type: Boolean,
      default: false,
    },
    withIcon: {
      type: Boolean,
      default: true,
    },
    iconPosition: {
      type: String,
      default: 'right',
      validator: val => ['left', 'right'].includes(val),
    },
    modifiers: {
      type: [Array, String],
      default: '',
    },
    inputGroupClass: {
      type: [Array, String],
      default: '',
    },
    disabled: Boolean,
  },
  data() {
    return {
      value: null,
    };
  },
  computed: {
    config() {
      return {
        static: true,
        ...this.options,
      };
    },
    isLeft() {
      return this.iconPosition === 'left';
    },
    isRight() {
      return this.iconPosition === 'right';
    },
    extraClasses() {
      let classes = '';
      if (Array.isArray(this.modifiers)) {
        classes = this.modifiers.filter(c => !!c).join(' ');
      } else if (typeof this.modifiers === 'string') {
        classes = this.modifiers;
      }
      return classes;
    },
    fpId() {
      const d = new Date();
      const hasIdProp = typeof this.id === 'string' && this.id.trim().length > 0;
      return hasIdProp ? this.id : `fp_${d.getTime()}`;
    },
    fpInstance() {
      // eslint-disable-next-line no-underscore-dangle
      return document.querySelector(`#${this.fpId}`)._flatpickr;
    },
  },
  methods: {
    onChange(e) {
      this.$emit('dp:change', { value: this.value, raw: this.$get(e, '0', null) });
      this.$emit('input', e[0]);
    },
    onClose(e) {
      this.$emit('dp:close', { value: this.value, raw: this.$get(e, '0', null) });
    },
    onOpen() {
      this.$emit('dp:open', { value: this.value });
    },
    togglePicker() {
      this.fpInstance.toggle();
    },
  },
};
</script>
